import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { IEntityUser, IPaginatedResponse } from '@boma/client-shared';
import { UsersService } from '@boma/supplier-portal/shared/services';

import { getSelectedOrganizationInfo } from '@boma/supplier-portal/shared/state';
import { Store } from '@ngrx/store';
import { take } from 'rxjs/operators';

@Component({
  selector: 'boma-search-entity-users',
  templateUrl: './search-entity-users.component.html',
  styleUrls: ['./search-entity-users.component.scss'],
})
export class SearchEntityUsersComponent implements OnInit {
  @Input() entityId: string;
  @Input() showLabels = true;
  @Input() label = 'Search Users';
  @Input() showHelp = true;
  @Input() multipleUsers = false;
  @Input() placeHolderText = 'All Users';
  @Input() dropdownClass: string;
  @Input() showArchivedUsers = false;
  userResults: IEntityUser[];
  selectedUsers: IEntityUser[] = null;
  userData: IPaginatedResponse<IEntityUser>;
  query: string = '';
  pageSize = 25;

  paginationData = {
    totalItems: null,
    totalPages: null,
    page: 1,
    nextPage: 1,
    previousPage: null,
  };

  @Output() sendSelectedUser = new EventEmitter<any>(); // IEntityUser[] // too many places to replace the event emitter for an array.

  loading: boolean = false;

  constructor(
    private usersService: UsersService,
    private store: Store
  ) {}

  ngOnInit(): void {
    if (!this.entityId) {
      this.store
        .select(getSelectedOrganizationInfo)
        .pipe(take(1))
        .subscribe((org) => {
          if (org) {
            this.entityId = org.id;
          }
        });
    }
  }
  createUserLabel(value) {
    if (!value) return null;
    //build the string
    let userLabel = value.user.fullName;
    if (value.employeeNumber) userLabel += ' (' + value.employeeNumber + ')';
    if (value.companyContactNumber || value.personalContactNumber)
      userLabel +=
        ' (' +
        (value.companyContactNumber || value.personalContactNumber) +
        ')';
    return userLabel;
  }
  search(event = null) {
    this.loading = true;
    this.query = event?.query ? event.query : this.query;
    this.usersService
      .listUsers(
        this.entityId,
        this.query,
        this.paginationData?.nextPage || 1,
        this.pageSize,
        this.showArchivedUsers
      )
      .subscribe({
        next: (data) => {
          data.items.map((x) => {
            x.user.fullName = x.user.firstName + ' ' + x.user.surname;
            return x;
          });

          this.userResults = data.items.map((x) => ({
            ...x,
            userLabel: this.createUserLabel(x),
          }));

          this.paginationData = {
            totalItems: data.totalItems,
            totalPages: data.totalPages,
            page: data.page,
            nextPage: data.nextPage,
            previousPage: data.previousPage,
          };
          this.loading = false;
        },
        error: (err) => {
          console.log(err);
          this.loading = false;
        },
        complete: () => {
          // add things you want to do once complete
        },
      });
  }

  clearSelect() {
    this.selectedUsers = null;
    this.sendSelectedUser.emit(this.selectedUsers);
  }

  handleSelect() {
    const value = this.multipleUsers
      ? this.selectedUsers
      : this.selectedUsers[0] || this.selectedUsers; // We just supporting the legacy here too many places to change right now

    this.sendSelectedUser.emit(value);
  }
}
